var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._l((_vm.langs),function(lang){return _c('span',{class:_vm.get_active(lang),on:{"click":function($event){$event.preventDefault();return _vm.set_lang(lang)}}},[_vm._v(_vm._s(lang))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }